import { createContext } from "react";

export const PricingContext = createContext();